"use client";

import { useEffect } from "react";
import { useCspNonce } from "@/components/csp-nonce-provider";
import { installGoogleTags } from "@/lib/google-tags";
import { useAnalyticsConsent } from "./ConsentProvider";

const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID?.trim();
const GA_ID = process.env.NEXT_PUBLIC_GA_ID?.trim();

/**
 * The Vite next/script compatibility component renders inert script markup on
 * client-side consent changes. Load the tags explicitly after consent so that
 * GA4 sessions can be recorded without activating optional tags beforehand.
 */
export function GoogleTagManager() {
  const { consentState } = useAnalyticsConsent();
  const nonce = useCspNonce();

  useEffect(() => {
    installGoogleTags(document, {
      consent: consentState,
      nonce,
      gaId: GA_ID,
      gtmId: GTM_ID,
    });
  }, [consentState, nonce]);

  return null;
}
